<template>
  <v-dialog v-model="dialog" content-class="detail-dialog" @click:outside="close" @keydown.esc="close">
    <v-toolbar>
      <v-toolbar-title>
        {{ fields[1].value || 'New product/service' }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="close"><v-icon>clear</v-icon></v-btn>
    </v-toolbar>
    <v-card flat :loading="loading" class="detail-dialog-card">
      <v-card-text>
        <v-form v-if="loaded">
          <v-container class="pt-2">
            <EditForm :items="fields" @data-changed="changed = true" ref="editForm" creating />
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col offset="6" cols="3" class="py-0">
              <v-btn block class="success" color="ligthen-2" :disabled="!changed" @click="save">
                <v-icon left>done</v-icon> Save
              </v-btn>
            </v-col>
            <v-col cols="3" class="py-0">
              <v-btn block :disabled="!changed" @click="reset">
                Reset
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import EditForm from '@/components/public/EditForm'

const SubModule = namespace('prodservice')

@Component({
  components: {
    EditForm
  }
})
export default class ProdServiceDetail extends Vue {
  dialog = false
  loaded = false
  loading = false
  accounts = []
  banks = []
  accountTypes = []
  itemId = null
  changed = false
  entityId = null

  @SubModule.Getter fields
  @SubModule.Getter requiredFields

  @SubModule.Action setFieldItems
  @SubModule.Action updateFromAPI

  open (entityId) {
    this.entityId = entityId
    console.log('open prod detail', this.entityId)
    this.dialog = true
    this.itemId = null
    this.loaded = false
    this.initNew()
    this.$nextTick(() => {
      this.loaded = true
    })
  }

  initNew () {
    this.fields.map(item => {
      item.value = ''
      item.text = ''
    })
  }

  close () {
    this.dialog = false
    this.$emit('close-detail')
  }

  save () {
    this.loading = true
    const data = this.$refs.editForm.save()
    if (this.entityId) {
      data.items.push({
        name: 'entity',
        value: this.entityId
      })
    }

    this.setFieldItems(data)
      .then(resp => {
        this.changed = false
        this.$emit('show-message', { message: 'Product/Service saved!' })
        this.close()
      })
      .catch(err => {
        const resp = err.response
        this.$emit('show-message', {
          message: 'Failed to save',
          error: resp.data.detail || resp.statusText
        })
      })
      .finally(() => {
        this.loading = false
      })
  }

  reset () {
    this.$refs.editForm.cancel()
    this.changed = false
  }

  load (pk) {
    this.loaded = false
    this.itemId = pk
    this.updateFromAPI(pk)
      .then(resp => {
        this.loaded = true
        this.dialog = true
      })
      .catch(err => {
        const resp = err.response
        this.$emit('show-message', {
          message: 'Failed to get detail',
          error: resp.data.detail || resp.statusText
        })
      })
  }
}
</script>
